// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.view-switcher-button {
    position: relative;
    z-index: 2;
}

div.view-switcher-buttons > button {
    transition: right 0.25s, box-shadow 0.25s;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
}

div.view-switcher-buttons:not(div.view-switcher-buttons-expanded) button {
    box-shadow: none;
}

div.view-switcher-buttons-expanded > button:nth-child(1) {
    right: 4em;
}

div.view-switcher-buttons-expanded > button:nth-child(2) {
    right: 8em;
}

div.view-switcher-buttons-expanded > button:nth-child(3) {
    right: 12em;
}

div.view-switcher-buttons-expanded > button:nth-child(4) {
    right: 16em;
}

div.view-switcher-buttons-expanded > button:nth-child(5) {
    right: 20em;
}`, "",{"version":3,"sources":["webpack://./qwc2/components/style/ViewSwitcher.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":["button.view-switcher-button {\n    position: relative;\n    z-index: 2;\n}\n\ndiv.view-switcher-buttons > button {\n    transition: right 0.25s, box-shadow 0.25s;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n}\n\ndiv.view-switcher-buttons:not(div.view-switcher-buttons-expanded) button {\n    box-shadow: none;\n}\n\ndiv.view-switcher-buttons-expanded > button:nth-child(1) {\n    right: 4em;\n}\n\ndiv.view-switcher-buttons-expanded > button:nth-child(2) {\n    right: 8em;\n}\n\ndiv.view-switcher-buttons-expanded > button:nth-child(3) {\n    right: 12em;\n}\n\ndiv.view-switcher-buttons-expanded > button:nth-child(4) {\n    right: 16em;\n}\n\ndiv.view-switcher-buttons-expanded > button:nth-child(5) {\n    right: 20em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
